import { Component, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { ReplaySubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LOCAL_STORAGE_LANG_KEY } from 'src/app/@core/constants/app';

@Component({
  selector: 'app-language-selection',
  templateUrl: './language-selection.component.html',
})
export class LanguageSelectionComponent implements OnDestroy {
  readonly translationPrefix = 'common.formFieldsLabels';
  readonly languages: string[];
  languageForm: FormGroup;


  private readonly destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);


  get languagePicker() {
    return this.languageForm.get('languagePicker');
  }

  constructor(private fb: FormBuilder, private languageService: TranslateService, private router: Router) {
    this.languages = this.languageService.getLangs();

    this.languageForm = this.fb.group({
      languagePicker: [localStorage.getItem(LOCAL_STORAGE_LANG_KEY) || null, Validators.required],
    });

    this.languagePicker.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe((lang: string) => this.languageService.use(lang))
  }


  submitSelection() {
    localStorage.setItem(LOCAL_STORAGE_LANG_KEY, this.languagePicker.value)
    this.router.navigate(['/dashboard']);
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }


}
